// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-Prisma-components-PrismaActions-PrismaActions-module__PrismaActions_modalContent";
var _2 = "webpack-pages-Prisma-components-PrismaActions-PrismaActions-module__PrismaActions_textarea";
var _3 = "webpack-pages-Prisma-components-PrismaActions-PrismaActions-module__PrismaActions_wrapper";
export { _1 as "PrismaActions_modalContent", _2 as "PrismaActions_textarea", _3 as "PrismaActions_wrapper" }
